function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { colors } from '../../../theme';
import { fonts } from '../../../theme';
import { createOwnUpStyle } from '../../style';
export var OwnUpHeaderStyle = createOwnUpStyle(_objectSpread(_objectSpread({}, fonts.TIEMPOS_HEADLINE_MEDIUM), {}, {
  color: colors.PRIMARY,
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '36px',
  lineHeight: '110%',
  margin: '0 auto 22px auto',
  variants: {
    /**
     * Title - Slightly larger
     */
    title: {
      fontSize: '42px',
      margin: '11px auto 30px auto'
    },

    /**
     * Section - Sans-serif; bold; and smaller
     */
    section: _objectSpread(_objectSpread({}, fonts.GRAPHIK_MEDIUM), {}, {
      fontSize: '18px',
      lineHeight: '135%',
      letterSpacing: '0.005em',
      margin: '20px auto 5px auto'
    }),

    /**
     * Greeting - Sans-serif; spaced; uppercase; and smaller
     */
    greeting: _objectSpread(_objectSpread({}, fonts.GRAPHIK_MEDIUM), {}, {
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '130%',
      textTransform: 'uppercase',
      letterSpacing: '1.5px',
      margin: '0 auto'
    }),

    /**
     * Box - Sans-serif; uppercase; and smaller
     */
    box: _objectSpread(_objectSpread({}, fonts.GRAPHIK_MEDIUM), {}, {
      fontSize: '12px',
      lineHeight: '130%',
      textTransform: 'uppercase',
      letterSpacing: '1.5px',
      margin: 'auto'
    }),

    /**
     * Modal - Slightly smaller
     */
    modal: {
      fontSize: '28px',
      lineHeight: '130%'
    }
  }
}));